module.exports = __webpack_public_path__ + "img/jugong1.2157879a.png";